<template>
  <div>
      <!-- <van-image :src="classDetial.detailsPictureUrl" class="p-t-05" fit="contain">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image> -->
      <img :src="classDetial.detailsPictureUrl" />
  </div>
</template>

<script>
export default {
  props:{
    classDetial:{
      type:Object,
      default:() => {
        return {}
      }
    }
  },
  data(){
    return {}
  }
}
</script>

<style scoped>

</style>